<template>
<div v-bind="{...$attrs}" :style="{width: size + 'px'}">
  <img v-if="size < 40" :width="size" class="loading-animation w-full h-full" src="../../assets/images/icons/ic_loading.svg" />
  <img v-else :width="size" class="loading-animation" src="../../assets/images/icons/ic_LoadingLarge.svg" />
</div>
</template>

<script>
export default {
  name: "Loading",
  props: ['size'],
}
</script>

<style scoped>

</style>
